define('templates',[
	"jquery",
	"handlebars",
	"handlebarsHelpers",
	"marionette"
],

function ($, Handlebars, HandlebarsHelpers, Marionette) {
	var prefix = "main/webapp/templates/";
	var fileExtension = ".html";

	var JST = window.JST || {};

	/**
	 * The Templating module is responsible for loading templates, compiling if necessary, 
	 * and setting them up inside our view engines.
	 */
	var Templates = {};
	
	Templates.getTemplate = function(name){

		var path = prefix + name + fileExtension;

			if(!JST[path]) {
				$.ajax({
					type: "GET",
					url: path,
					async: false,
					global: false, //do not grey out screen for these requests
					success: function(html) {
						JST[path] = html;
					}
				});
			}
			
			return Handlebars.template(JST[path]);
	};


	Templates.init = function() {
		Marionette.TemplateCache.prototype.loadTemplate = function(name) {
			
			var path = prefix + name + fileExtension;

			if(!JST[path]) {
				$.ajax({
					type: "GET",
					url: path,
					async: false,
					global: false, //do not grey out screen for these requests
					success: function(html) {
						JST[path] = html;
					}
				});
			}

			return JST[path];
		};

		Marionette.TemplateCache.prototype.compileTemplate = function(html) {
			if(typeof html === "object") {
				return Handlebars.template(html);
			}
			return Handlebars.compile(html);
			
		};
	 };

	return Templates;
});
